require('./index-pro-style-only');

module.exports = require('./components-pro');
